<script setup lang="ts">
import { ICONS } from '~ds/lib/icons';
import KUICoreButtonIcon from '~kui/components/KUI/Core/Button/Icon/KUICoreButtonIcon.vue';

interface Props {
  inline?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  inline: false,
});

defineEmits<{
  back: [];
}>();

const positionClasses = computed(() =>
  twMerge(
    cva('', {
      variants: {
        inline: {
          true: '',
          false: 'absolute top-2 left-2 z-50',
        },
      },
    })({
      inline: props.inline,
    }),
  ),
);
</script>

<template>
  <KUICoreButtonIcon
    :icon="ICONS.arrowLeft"
    size="sm"
    variant="white"
    :aria-label="$t('unified.common.back')"
    :class="positionClasses"
    @click="$emit('back')"
  />
</template>
